import Item from './Item';

const STATE_RAW = 1;
const STATE_COOKED = 2;
const STATE_BURNT = 3;

export default class StickWithFood extends Item {
  constructor({ game, location, data }) {
    super({ game, location, data });
    this.cookTime = 0;
    this.state = STATE_RAW;

    this.isStick = true;
  }

  init(itemData) {
    if (itemData && itemData.state) {
      this.setState(itemData.state);
    }

    super.init(itemData);
  }

  getPosForAnts() {
    return { x: this.x + 80, y: this.y };
  }

  step(dt) {
    super.step(dt);
    if (this.drag && this.pointer && this.location.campfire.isLit) {
      const ca = this.location.campfire.cookArea;
      const overFire = Phaser.Rectangle.contains(ca, this.x - 65, this.y - 65);
      if (overFire) {
        if (this.state !== STATE_BURNT) {
          // cook
          this.cookTime += dt;
          if (this.cookTime > 3 && this.state === STATE_RAW) {
            this.setState(STATE_COOKED);
            this.game.sounds.playSFX('item_cook', { spriteID: 'sfx' });
          } else if (this.cookTime > 6 && this.state === STATE_COOKED) {
            this.setState(STATE_BURNT);
            this.game.sounds.playSFX('item_cook', { spriteID: 'sfx' });
          }
        }

        // skew over the fire
        if (this.angle !== -45 && (!this.tweenOver || this.tweenOut)) {
          if (this.tweenOut) {
            this.tweenOut.stop();
            this.tweenOut = null;
          }
          this.tweenOver = this.game.add.tween(this).to({ angle: -45 }, 150, null, true);
        }
      } else if (this.angle !== 0 && (this.tweenOver || !this.tweenOut)) {
        // make it straight
        if (this.tweenOver) {
          this.tweenOver.stop();
          this.tweenOver = null;
        }
        this.tweenOut = this.game.add.tween(this).to({ angle: 0 }, 150, null, true);
      }
    }
  }

  setState(state) {
    this.state = state;
    if (this.state === STATE_COOKED) {
      this.frameName = this.id + '_cooked';
      this.cookTime = 3.01;
    } else if (this.state === STATE_BURNT) {
      this.state = STATE_BURNT;
      this.frameName = this.id + '_burnt';
      this.cookTime = 6.01;
    }
  }

  isCooked() {
    return this.state === STATE_COOKED;
  }

  handleStartDrag() {
    this.game.add.tween(this).to({ angle: 0 }, 150, null, true);
  }

  hitGround() {
    this.game.add.tween(this).to({ angle: 90 }, 150, null, true);
  }

  canBeTrashed() {
    return !this.trashed && (this.hasFlag('trashable') || this.state === STATE_BURNT);
  }

  canBeHold() {
    return this.hasFlag('hold'); // && this.state !== STATE_BURNT;
  }

  //
  serialize() {
    const data = super.serialize();
    if (data) {
      data.state = this.state;
    }
    return data;
  }
}
